import * as React from 'react';
import type { Invoice } from 'contracts/tracking-v2/invoices';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import { cn } from 'lib/utils';

import { CompanyCard } from './company-card';

type Props = React.ComponentProps<'div'>

export const InvoiceCompaniesGrid = ({ className, ...props }: Props) => {
  const { invoice } = useInvoiceStore();

  return (
    <div {...props} className={cn('grid grid-cols-1 xl:grid-cols-3 gap-4', className)}>
      <CompanyCard
        cardTitle={'Remetente'}
        tradeName={invoice?.supplier?.tradeName}
        cnpj={invoice?.supplier?.document}
        address={getAddress(invoice?.supplier)}
        loading={!invoice}
      />
      <CompanyCard
        cardTitle={'Transportadora'}
        tradeName={invoice?.carrier?.tradeName}
        cnpj={invoice?.carrier?.document}
        address={getAddress(invoice?.carrier)}
        loading={!invoice}
      />
      <CompanyCard
        cardTitle={'Destinatário'}
        tradeName={invoice?.company?.tradeName}
        cnpj={invoice?.company?.document}
        address={getAddress(invoice?.company)}
        loading={!invoice}
      />
    </div>
  );
};

const getAddress = (
  company?: Invoice['company'] | Invoice['carrier'] | Invoice['supplier'],
) => {
  if (!company) return undefined;

  const {
    address = '',
    addressStreet,
    addressNumber,
    addressNeighborhood,
    addressCity,
    addressState = '',
  } = company as Invoice['company'];

  const completeAddress = [
    addressStreet,
    ...(addressNumber === 'SN' ? [] : [addressNumber]),
    addressNeighborhood,
    addressCity,
    addressState,
  ].filter(Boolean).join(', ') || address;

  return completeAddress || undefined;
};